import { render, staticRenderFns } from "./yearReport.vue?vue&type=template&id=54c1901e&scoped=true&"
import script from "./yearReport.vue?vue&type=script&lang=js&"
export * from "./yearReport.vue?vue&type=script&lang=js&"
import style0 from "./yearReport.vue?vue&type=style&index=0&id=54c1901e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c1901e",
  null
  
)

export default component.exports